"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _valid = _interopRequireDefault(require("semver/ranges/valid"));
function parsePackageVersion(version) {
  if (version) {
    var rangedVersion = (0, _valid.default)(version);
    if (rangedVersion) {
      return rangedVersion;
    }
  }
  return '';
}
var _default = exports.default = parsePackageVersion;